import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import CurrencyIndex from './currency-index';
import CurrencyIndexDetail from './currency-index-detail';
import CurrencyIndexUpdate from './currency-index-update';
import CurrencyIndexDeleteDialog from './currency-index-delete-dialog';
import PrivateRoute from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute exact path={`${match.url}/new`} component={CurrencyIndexUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id/edit`} component={CurrencyIndexUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={CurrencyIndexDetail} />
      <ErrorBoundaryRoute path={match.url} component={CurrencyIndex} />
    </Switch>
    <PrivateRoute exact path={`${match.url}/:id/delete`} component={CurrencyIndexDeleteDialog} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
  </>
);

export default Routes;
